// FLAGS: none
// Chrome for every signed-in scheduler surface: brand header, the signed-in email, sign-out, and the outlet.
import { CalendarDays, LogOut } from "lucide-react";
import { Link, Outlet, useNavigate } from "react-router";
import { Button } from "@openup/shared/primitives/ui/button";
import { useCurrentUser, useLogoutMutation } from "@src/queries/auth";

const AppShell = () => {
  const navigate = useNavigate();
  const { data: user } = useCurrentUser();
  const logoutMutation = useLogoutMutation();

  const onSignOut = () => {
    logoutMutation.mutate(undefined, {
      onSettled: () => navigate("/login", { replace: true }),
    });
  };

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
          <Link to="/events" className="flex items-center gap-2">
            <CalendarDays className="h-6 w-6 text-green-700" aria-hidden />
            <span className="text-lg font-semibold text-indigo-800">
              OpenUp Spaces
            </span>
          </Link>
          <div className="flex items-center gap-4">
            <span className="hidden text-sm text-gray-600 sm:inline">
              {user?.email}
            </span>
            <Button
              variant="ghost"
              size="default"
              onClick={onSignOut}
              disabled={logoutMutation.isPending}
            >
              <LogOut className="mr-1 h-4 w-4" aria-hidden />
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AppShell;
